import { Component, Input, OnInit, SimpleChanges, effect } from "@angular/core";
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from "@angular/router";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { TableModule } from 'primeng/table';
import { TabViewModule } from "primeng/tabview";
import { DonorCardService } from "../../services/donor-card.service";
import { MainModel } from "../../../global/model/MainModel";
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from "@angular/forms";
import { ChartModule } from 'primeng/chart';
import { DonorFundTotalsGridComponent } from "../../shared-components/donor-fund-totals-grid/donor-fund-totals-grid.component";
import { SidebarModule } from 'primeng/sidebar';
import { DonorAddComponent } from "../donor-add/donor-add.component";
import { DonorFormModel } from "../../models/DonorModel";
import { LoadingSpinnerComponent } from "../../../global/component/loading-spinner/loading-spinner.component";
import { DialogModule } from "primeng/dialog";
import { GenericButtonComponent } from "../../../global/component/generic/generic-button/generic-button.component";
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ToastModule } from 'primeng/toast';
import { DonorType } from "../../models/ConstantsAndEnums";
import { SharedService } from "../../services/shared.service";
import { DonorLettersComponent } from "./donor-letters/donor-letters.component";
import { DonorNotesComponent } from "./donor-notes/donor-notes.component";
import { TagModule } from "primeng/tag";
import { DonorDonationsComponent } from "./donor-donations/donor-donations.component";
import { DonorLifetimeHistoryComponent } from "../../shared-components/donor-lifetime-history/donor-lifetime-history.component";
import { CurrentCycleDonationsComponent } from "../../shared-components/current-cycle-donations/current-cycle-donations.component";
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'app-donor-card',
  templateUrl: './donor-card.component.html',
  styleUrls: ['./donor-card.component.scss'],
  standalone: true,
  imports: [FormsModule, TabViewModule, CardModule, ButtonModule,
    CommonModule, TableModule, CheckboxModule, GenericButtonComponent, 
    CalendarModule, DropdownModule, InputTextareaModule, ChartModule,
    DonorFundTotalsGridComponent, SidebarModule, DonorAddComponent,
    LoadingSpinnerComponent, DialogModule, ToastModule, TagModule, SkeletonModule,
    DonorLettersComponent, DonorNotesComponent, DonorDonationsComponent,
    DonorLifetimeHistoryComponent, CurrentCycleDonationsComponent],
  providers: [DonorCardService, SharedService]
})
export class DonorCardComponent implements OnInit {
  campaignId: number = 0;
  donorId: number = 0;
  isDonorTypeIndividual: boolean = false;
  generalInfo: any = null;
  addresses: any[] = [];
  phoneNumbers: any[] = [];
  emailAddresses: any[] = [];
  expandedRows = {};
  // donorLetters = [];
  donorCallsheetsLog = [];
  donorNotes = [];
  donorFlags = [];
  donorRelationships = [];
  donorSalutations: any = {};
  donorSuppression: any = {};
  fundcodesHistory: any = [];

  // dialog modals
  showAddDonorLetterDialog: boolean = false;
  showAddNewNoteDialog: boolean = false;
  showAddDonationDialog: boolean = false;

  tabIndex = 0;
  activeTab = 0;
  donorToEdit: DonorFormModel | null = null;
  editStep = 1;
  @Input({ required: true }) isDockable: boolean = true;
  isDonorEditSidebarVisible: boolean = false;
  isDonorEditDataLoading: boolean = false;
  @Input() isModalPopup: boolean = false;
  @Input() fromSearchDonorID: any;

  constructor(private route: ActivatedRoute,
    private mainModel: MainModel,
    private donorCardService: DonorCardService,
    public sharedService: SharedService) {

      const id = this.route.snapshot.paramMap.get('id') ?? '';
      this.donorId = parseInt(id);
      
      effect(() => {
        const c: any = this.mainModel.selectedCampaign();
        this.campaignId = parseInt(c?.campaignId);

        this.loadData();
      });
  }

  loadData(){
    this.loadGeneralInformation();
    this.loadContactInformation();
    this.loadDonorCallsheetsLog();
    this.loadDonorFlags();
    this.loadDonorRelationships();
    this.loadDonorSalutations();
    this.loadDonorSuppression();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fromSearchDonorID']) {
      const id = this.fromSearchDonorID ? this.fromSearchDonorID : this.route.snapshot.paramMap.get('id') ?? '';
      this.donorId = parseInt(id);

      if(this.donorId){
        this.loadData();
      }
    }
  }

  
  tabs = {
    Contact: 0,
    General: 1,
    Relationships: 2,
    DonorLetters: 3,
    // CallSheetLog: 4,
    Notes: 4,
    DonorFlags: 5,
    Salutation: 6,
    Supression: 7
  }

  switchTab(selectedTab: any) {
    this.activeTab = selectedTab.index;
    this.editStep = -1;

    switch (this.activeTab) {
      case this.tabs.General: {
        this.editStep = 0;
        // this.loadGeneralInformation();
        break;
      }
      case this.tabs.Contact: {
        this.editStep = 1;
        // this.loadContactInformation();
        break;
      }
      case this.tabs.Relationships: {
        this.editStep = 2;
        break;
      }
      case this.tabs.DonorLetters: {
        // this.loadDonorLetters();
        break;
      }
      // case this.tabs.CallSheetLog: {
      //   // this.loadDonorCallSheetLog();
      //   break;
      // }
      case this.tabs.Notes: {
        // this.loadDonorNotes();
        break;
      }
      case this.tabs.DonorFlags: {
        this.editStep = 3;
        break;
      }
      case this.tabs.Salutation: {
        this.editStep = 3;
        break;
      }
      case this.tabs.Supression: {
        this.editStep = 3;
        break;
      }
    }
  }

  // general-info endpoint
  loadGeneralInformation(): void {
    if (!isNaN(this.donorId) && this.donorId > 0
        && !isNaN(this.campaignId) && this.campaignId > 0) {
      this.donorCardService.getDonorCardGeneralInfo(this.donorId, this.campaignId).subscribe({
        next: data => {
          this.generalInfo = data;
          this.isDonorTypeIndividual = (this.generalInfo?.donorTypeId == DonorType.Candidate
                                          || this.generalInfo?.donorTypeId == DonorType.Individual);
        },
        error: err => {
          console.error('Unable to retrieve general information. Please try again later.', err);
        },
        complete: () => console.debug("general-info service call complete")
      });
    }
  }

  loadContactInformation(): void {
    if (!isNaN(this.donorId) && this.donorId > 0) {
      this.donorCardService.getDonorCardContactInfo(this.donorId).subscribe({
        next: data => {
          this.addresses = data.addresses || [];
          this.addresses.sort((a, b) => Number(b.isPrimaryString === 'Yes') - Number(a.isPrimaryString === 'Yes'));
          this.phoneNumbers = data.phones || [];
          this.emailAddresses = data.emails || [];
        },
        error: err => {
          console.error('Unable to retrieve contact information. Please try again later.', err);
        },
        complete: () => console.debug("contact-info service call complete")
      });
    }
  }
  
  loadDonorCallsheetsLog(): void {
    if (!isNaN(this.donorId) && this.donorId > 0) {
      // const c: any = this.mainModel.selectedCampaign();
      // const campaignId: number = parseInt(c?.campaignId);
      // If campaign is not loaded, then we can't load donor flags
      if (isNaN(this.campaignId) || this.campaignId <= 0)
        return;

      this.donorCardService.getDonorCardCallsheetsLog(this.campaignId, this.donorId).subscribe({
        next: data => {
          console.debug(data);
          this.donorCallsheetsLog = data;
        },
        error: err => {
          console.error('Unable to retrieve donor callsheets log. Please try again later.', err);
        },
      });
    }
  }


  loadDonorFlags(): void {
    if (!isNaN(this.donorId) && this.donorId > 0) {
      this.donorCardService.getDonorFlags(this.donorId).subscribe({
        next: data => {
          console.debug(data);
          this.donorFlags = data;
        },
        error: err => {
          console.error('Unable to retrieve donor flags. Please try again later.', err);
        },
      });
    }
  }

  loadDonorSalutations(): void {
    if (!isNaN(this.donorId) && this.donorId > 0) {
      this.donorCardService.getDonorSalutations(this.donorId).subscribe({
        next: data => {
          console.debug(data);
          this.donorSalutations = data;
        },
        error: err => {
          console.error('Unable to retrieve donor salutations. Please try again later.', err);
        },
      });
    }
  }

  loadDonorSuppression(): void {
    if (!isNaN(this.donorId) && this.donorId > 0) {
      this.donorCardService.getDonorSuppression(this.donorId).subscribe({
        next: data => {
          console.debug(data);
          this.donorSuppression = data;
        },
        error: err => {
          console.error('Unable to retrieve donor suppression data. Please try again later.', err);
        },
      });
    }
  }

  loadDonorRelationships(): void {
    if (!isNaN(this.donorId) && this.donorId > 0) {
      this.donorCardService.getDonorRelationships(this.donorId).subscribe({
        next: data => {
          this.donorRelationships = data;
        },
        error: err => {
          console.error('Unable to retrieve donor relationships. Please try again later.', err);
        },
      });
    }
  }

  ngOnInit(): void {
    
  }

  getRemainingFlag(remaining: string) {
    if (parseFloat(remaining) < 0) {
      return 'danger';
    }
    return null;
  }

  onFundcodesHistoryLoaded(fundcodesHistory: any)
  {
    this.fundcodesHistory = fundcodesHistory;
  }

  editDonor() {
    this.isDonorEditSidebarVisible = true;
    this.isDonorEditDataLoading = true;
    this.loadDonorDataForEdit();
  }

  loadDonorDataForEdit(): void {    
    if (!isNaN(this.donorId) && this.donorId > 0) {
      this.donorCardService.getDonorForEdit(this.donorId).subscribe({
        next: data => {
          console.debug(data);
          this.isDonorEditDataLoading = false;
          this.donorToEdit = data;
        },
        error: err => {
          console.error('Unable to retrieve donor data for editing. Please try again later.', err);
        },
      });
    }
  }

  closeModal() {
    this.isDonorEditSidebarVisible = false;
  }

}
